import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { DeudaAdicionalPendiente } from "src/app/models/PlanesUsuario/DeudaAdicionalPendiente";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import Swal from "sweetalert2";
@Component({
	selector: "app-deuda-adicional-card",
	templateUrl: "./deuda-adicional-card.component.html",
	styleUrls: ["./deuda-adicional-card.component.scss"],
})
export class DeudaAdicionalCardComponent {
	@Input() deuda: DeudaAdicionalPendiente = new DeudaAdicionalPendiente();
	@Input() pagando = false;
	@Input() mensaje = "Debes pagar el total de esta deuda para poder regularizar tu plan. No se permiten pagos parciales.";
	@Output() pagar = new EventEmitter<void>();

	public cargandoPdf = false;

	constructor(
		private planUsuarioService: PlanUsuarioService,
		private utilities: UtilitiesService,
		private ref: ChangeDetectorRef
	) {}

	get tieneDeuda(): boolean {
		return this.deuda?.tieneDeuda ?? false;
	}

	onPagar(): void {
		if (this.pagando) return;
		this.pagar.emit();
	}

	verFacturaPdf(facturaId: string): void {
		if (!facturaId || this.cargandoPdf) return;

		this.cargandoPdf = true;
		this.ref.detectChanges();
		this.planUsuarioService.getFacturaPDF(facturaId).subscribe({
			next: (data) => {
				this.cargandoPdf = false;
				this.ref.detectChanges();
				const pdfBlob = this.utilities.convertB64ToBlob(data.data, "application/pdf");
				window.open(URL.createObjectURL(pdfBlob), "_blank");
			},
			error: () => {
				this.cargandoPdf = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "No se pudo obtener el documento",
					text: "No fue posible generar el PDF de la factura. Intenta nuevamente o contacta a soporte.",
				});
			},
		});
	}
}
